// extracted by mini-css-extract-plugin
export default {"needToKnow":"NeedToKnow_needToKnow__euged","needToKnow__content":"NeedToKnow_needToKnow__content__T+5Mb"};